// AUTO-GENERATED - DO NOT EDIT!
import gql from "graphql-tag";
import { useQuery, QueryHookOptions } from "@apollo/client";
import { whatsNewCount, whatsNewCountVariables } from "../types/whatsNewCount";

export const useWhatsNewCountQuery = (
  opts: QueryHookOptions<whatsNewCount, whatsNewCountVariables>
) => {
  return useQuery<whatsNewCount, whatsNewCountVariables>(whatsNewCountQuery, {
    ...opts,
    context: { ...opts.context, cms: true }
  });
};

export const whatsNewCountQuery = gql`
  query whatsNewCount($lastUpdate: DateTime, $flags: [String]) {
    _allProductUpdatesMeta(
      filter: {
        web: { eq: true }
        date: { gt: $lastUpdate }
        OR: [{ featureFlag: { in: $flags } }, { featureFlag: { eq: "" } }]
      }
    ) {
      count
    }
  }
`;

export function refetchWhatsNewCountQuery(variables: whatsNewCountVariables) {
  return {
    query: whatsNewCountQuery,
    variables
  };
}
